import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Params } from '@angular/router';
import { FacetConfigResponse as FacetGroup } from '@models/api-search.models';
import { SameDayDeliveryParams } from '@features/product-filter/same-day-delivery-facet/same-day-delivery-facet.model';
import { FacetGroupsWithValuesPipe } from '@features/product-filter/pipes/facet-groups-with-values.pipe';
import { TranslateSafePipe } from '../../../@shared/translate-safe/translate-safe.pipe';
import { SvgIconComponent } from '../../../@shared/svg-icon/svg-icon.component';
import { FilterSelectComponent } from '../filter-select/filter-select.component';
import { NgClass, NgFor, NgIf, SlicePipe } from '@angular/common';
import { SameDayDeliveryFacetComponent } from '../same-day-delivery-facet/same-day-delivery-facet.component';
import { SameDayDeliveryInOffModeDirective } from '../../../@shared/same-day-delivery/same-day-delivery-in-off-mode.directive';
import { StoreStockFacetComponent } from '../store-stock-facet/store-stock-facet.component';

@Component({
    selector: 'app-filter-facets',
    templateUrl: './filter-facets.component.html',
    styleUrls: ['./filter-facets.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [StoreStockFacetComponent, SameDayDeliveryInOffModeDirective, SameDayDeliveryFacetComponent, NgClass, NgFor, FilterSelectComponent, NgIf, SvgIconComponent, SlicePipe, TranslateSafePipe, FacetGroupsWithValuesPipe]
})
export class FilterFacetsComponent {
    public facetsActive: boolean;
    public activeKey: string | null = null;
    public expanded: boolean = false;
    public maxVisibleFacets = 8;
    public infinity = Infinity;
    public storeStockDisabled: boolean = false;

    @Input()
    public readonly facetGroups?: FacetGroup[];

    @Output()
    public readonly facetUpdate: EventEmitter<Params> = new EventEmitter();

    constructor(private readonly cd: ChangeDetectorRef) {}

    public onExpandUpdate(isExpanded: boolean, key?: string): void {
        if (!key) {
            return;
        }

        if (this.activeKey === key && !isExpanded) {
            this.activeKey = null;
        }

        if (isExpanded) {
            this.activeKey = key;
        }
    }

    public onFacetUpdate(param: Params): void {
        this.facetUpdate.emit(param);
    }

    public onSameDayDeliveryChange(params: SameDayDeliveryParams): void {
        this.storeStockDisabled = params.sameDayDeliveryIsActive;
        this.cd.markForCheck();
    }

    public trackFacetFn(index: number, group: FacetGroup): string {
        return group.key || `group-${index}`;
    }
}
